import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useFormFields } from "../../libs/hooksLibs";
import useModal from "../helpers/useModal";
import inputStyle from "../../styles/UserProfileInput.module.scss";
import { validateText } from "../../utils/formUtils";
import styles from "../../styles/Profile.module.scss";
import currentUserInfo from "../../selectors/currentUserInfo";
import currentUserScreenName from "../../selectors/currentUserScreenName";
import Spinner from "../../components/Spinner";
import ProfilePersonalInformation from "../helpers/ProfilePersonalInformation";
import Log from "../../utils/Log";
import { setUser, validateToken } from "../../actions/auth";
import GenericModal from "../helpers/GenericModal";
import UserPasswordReset from "../account/UserPasswordReset";
import { ValidateScreenName } from "../../constants/profanityHelper";

import {
  updateUserAttributes,
  changeCognitoPassword,
} from "../../utils/CognitoUtils";
import { handleUpdateUserScreenName } from '../../actions/auth';

export default function UserProfile() {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserInfo);
  const currentScreenName= useSelector(currentUserScreenName)
  const [isLoading, setIsLoading] = useState(true);
  const [updateErrorText, setUpdateErrorText] = useState(null);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState(""); //can't change this value
  const [name, setName] = useState("");
  const [phone] = useState("xxx-xxx-xxxx");
  const [country, setCountry] = useState("United States of America"); //
  const [screenName, setScreenName] = useState("");
  const [ screenNameError, setScreenNameError] = useState(null);

  const [passwords, updatePasswords] = useFormFields({
    password: "",
    newPassword: "",
  });
  const [errorStateObject, updateInputErrorState] = useFormFields({
    email: "",
    username: "",
    name: "",
    phone: "",
    password: "",
    newPassword: "",
    country: "",
    screenName: ""
  });
  const [ updateStatus, setUpdateStatus] = useState("");
  const [ updateSuccessful, setUpdateSuccessful] = useState(false);
  const [ updateScreenNameSuccessful, setUpdateScreenNameSuccessful] = useState(false);

  const { isShowing, toggle } = useModal();

  const spinnerStyle = {
    height: "50px",
    width: "50px",
  };

  const modalStyle = {
    maxWidth: "600px",
  };

  const formStyles = {
    title: "",
    alignItems: "center",
    border: true,
    darkMode: false,
    padding: "36px",
    paymentFormBackground: "white",
    height: "100%",
    width: "100%",
  };

  const modalHeaderStyle = {
    backgroundColor: "#222222",
  };

  useEffect(() => {
    if (currentUser) {
      setEmail(currentUser.email);
      setUsername(currentUser.username);
      setName(currentUser.name);
      setCountry(currentUser.country);
      setTimeout(() => {
        setIsLoading(false);
      }, 1200);
    }
  }, [currentUser]);

  useEffect(() => {
    setScreenName("")
  }, [currentScreenName])

  const inputStyles = {
    container: inputStyle.inputWrapper,
    label: inputStyle.inputLabel,
    input: inputStyle.genericInput,
    error: inputStyle.error,
    errorMessage: inputStyle.errorText,
    icon: inputStyle.inputIcon,
    passwordIcon: inputStyle.passwordIcon,
    resetPassword: inputStyle.resetPassword,
    flexWrapper: styles.flexWrapper,
    submitButton: styles.updateBtn,
    messages: styles.messages,
    successIcon: styles.successIcon,
    buttonContainer: styles.buttonContainer,
    changePasswordBtn: styles.changePasswordBtn,
    dropdownWrapper: inputStyle.dropdownWrapper,
    profileIcon: styles.profileIcon,
  };

  const profileContainerClass = inputStyle.container;

  function togglePasswordVisiblity() {
    setPasswordShown(!passwordShown);
  }

  function handleFieldChange(inputName, value) {
    if (validateText(value)) {
      updateInputErrorState(inputName, false);
    } else {
      if(inputName !== 'screenName'){
        updateInputErrorState(inputName, true);
      }
    }
    setUpdateErrorText(null);

    switch (inputName) {
      case "newPassword":
      case "password":
        validatePasswordsOnFieldChange();
        updatePasswords(inputName, value);
        setPasswordError(false);
        break;
      case "username":
        setUsername(value.replace(/\s+/g, ""));
        break;
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "country":
        setCountry(value);
        break;
      case 'screenName':
        setScreenName(value);
        break;
      default:
        console.log("unknown category");
        break;
    }
  }

  function validatePasswords() {
    // eslint-disable-next-line
    const pwRegex = RegExp(/^(?=.*\d).{8,}$/);
    setPasswordError(false);

    if (!pwRegex.test(passwords.newPassword)) {
      // setUpdateErrorText("Passwords do not match requirements");
      setPasswordError("Passwords do not match requirements");
      return false;
    }

    return true;
  }

  function validatePasswordsOnFieldChange() {
    const pwRegex = RegExp(/^(?=.*\d).{8,}$/);
    setPasswordError(false);

    if (!pwRegex.test(passwords.password)) {
      setPasswordError(true);
      return false;
    }

    return true;
  }

  function validateEmail() {
    const emailRegex = RegExp( //eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (!emailRegex.test(email)) {
      setUpdateErrorText("Invalid email format");
      updateInputErrorState("email", true);

      return false;
    }

    return true;
  }

  function validateForm(field) {
    let fieldsAreValid = field !== "";

    if (!fieldsAreValid) {
      const currentErrorObject = { ...errorStateObject };
      if (!validateText(field)) {
        currentErrorObject[field] = true;
      }
      setUpdateErrorText("Please fill out all required fields");
      updateInputErrorState(null, currentErrorObject);
    }

    return fieldsAreValid;
  }


  function validateScreenName() {
    const screenNameChecker = new ValidateScreenName();    
    const lowercasedName = screenName.toLowerCase()

    if (!screenNameChecker.validateScreenName(lowercasedName) || screenNameChecker.hasBadWordEng(lowercasedName)){
      setScreenNameError("Buildbox World Creator name issue");
      updateInputErrorState('screenName', true);
      return false;
    }

    return  true
  }

  function changePasswordClicked() {
    updatePasswords(null, { password: "", newPassword: "" });
    toggle();
  }

  async function handlePasswordChange() {
    if (!validatePasswords()) {
      return false;
    }
    const accessToken = await dispatch(validateToken());

    try {
      const response = await changeCognitoPassword(
        accessToken,
        passwords.password,
        passwords.newPassword
      );
      Log.info(response, "Response from changeCognitoPassword:");
      toggle();
      toast.success("Password successfully updated!");
      setUpdateSuccessful(true);
    } catch (error) {
      Log.error(error, "User Profile update password error:");
      setUpdateErrorText("Your password could not be updated");
      setUpdateSuccessful(false);
      toast.error("Your password could not be updated");
    }

    // Auth.currentAuthenticatedUser()
    //   .then((user) => {
    //     return Auth.changePassword(
    //       user,
    //       passwords.password,
    //       passwords.newPassword
    //     );
    //   })
    //   .then((data) => {
    //     toggle();
    //     toast.success("Password successfully updated!");
    //     setUpdateSuccessful(true);
    //   })
    //   .catch((error) => {
    //     Log.error(error, "User Profile update password error:");
    //     setUpdateErrorText("Your password could not be updated");
    //     setUpdateSuccessful(false);
    //     toast.error("Your password could not be updated");
    //   });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    try {

      if (!validateForm(name) || !validateEmail()) {
        return;
      }

      if( name !== currentUser.name || country !== currentUser.country ){
        await updateUserInfo();
      }

      if( screenName.length >0 && validateScreenName()){
        console.log("here")
        await updateUserScreenName();
      }

    } catch (error) {
      Log.error(error, "User Profile handleSubmit error:");
      // const errorMessage = getErrorMessage(e);
      setUpdateErrorText(error);
    }
  }

  async function updateUserScreenName(){
    try{ 
      const newScreenName = await dispatch(handleUpdateUserScreenName(screenName));
      setScreenName(newScreenName)
      setUpdateScreenNameSuccessful(true);
      updateInputErrorState('screenName', false);
    }catch(error){
      setScreenNameError(error);
      updateInputErrorState('screenName', true);
      setUpdateScreenNameSuccessful(false);
    }
  }

  async function updateUserInfo() {
    const accessToken = await dispatch(validateToken());

    const userAttributes = {
      email: email,
      name: name,
      picture: "myprofilepic.png",
      locale: country,
    };
    try {
      const response = await updateUserAttributes(accessToken, userAttributes);
      Log.info(response, "Response from updateUserAttributes:");

      if (response.status === 200) {
        const userObject = {
          username: username,
          name: name,
          uuid: currentUser.uuid,
          email: email,
          isNewUser: false,
          referralInfo: currentUser.referralInfo
        };

        // toast.success("Your information was successfully updated!");
        setUpdateSuccessful(true);
        setUpdateStatus("Your information was successfully updated!");
        dispatch(setUser(userObject));
      }
    } catch (error) {
      Log.error("User Profile update user info error:");
      setUpdateErrorText("There was an issue updating your user information.");
      setUpdateSuccessful(false);
      toast.error("There was an issue updating your user information.");
    }
  }

  function showErrorText() {
    if (updateErrorText) {
      return updateErrorText;
    } else {
      return null;
    }
  }

  const profileInfoProps = {
    errorStateObject,
    handleFieldChange,
    isLoading,
    updateErrorText,
    togglePasswordVisiblity,
    inputStyles,
    passwordError,
    showErrorText,
    profileContainerClass,
    handleSubmit,
    updateStatus,
    updateSuccessful,
    changePasswordClicked,
    formStyles,
    email,
    name,
    username,
    phone,
    country,
    screenName,
    currentScreenName,
    updateScreenNameSuccessful,
    screenNameError
  };

  const resetPasswordProps = {
    inputStyles,
    errorStateObject,
    passwords,
    handleFieldChange,
    handlePasswordChange,
    profileContainerClass,
    togglePasswordVisiblity,
    passwordShown,
    passwordError,
    updateErrorText,
  };

  return (
    <div className={styles.profileWrapper}>
      <div>
        <h1>Personal Information</h1>
        {isLoading ? (
          <div className={styles.spinnerWrapper}>
            <Spinner isLoading={isLoading} spinnerStyle={spinnerStyle} />
          </div>
        ) : (
          <div className={styles.personalInfoContainer}>
            <ProfilePersonalInformation {...profileInfoProps} />
          </div>
        )}
        <GenericModal
          isShowing={isShowing}
          hide={toggle}
          modalStyle={modalStyle}
          modalHeaderStyle={modalHeaderStyle}
          darkMode
        >
          <UserPasswordReset {...resetPasswordProps} />
        </GenericModal>
      </div>
    </div>
  );
}
